import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import TabNavItem from '../elements/TabNavItem'
import DataSource from '../DataSource'
import ResponsiveTable from '../components/ResponsiveTable'
import Pagination from '../components/Pagination'

class AccountOverview extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            invoices: []
        }
    }

    componentDidMount () {
        DataSource.getData('/api/getInvoices/1', response => {
            this.setState({
                invoices: response.invoices.slice(0, 3),
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
        const headings = ['Invoice date', 'Due date', 'Invoice no.', 'Amount', 'View PDF']

        return (
            <div className='account-balance module'>
                <Heading title='Account overview'>
                    <div className='col-md-7 col-12 mt-md-0 mt-2 d-flex align-items-center justify-content-md-end'>{this.props.customerName}</div>
                </Heading>
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4 text-center text-md-left'>
                    <div className='row'>
                        <div className='col-12 col-lg-8 offset-lg-2 text-center'>
                            <p>
                                Your nominated credit card or bank account will be debited on or around the due date for each invoice. Or if you need to make a manual payment now, you can do so here.
                                If you make a manual payment, we’ll send you a confirmation email straight away, a new invoice will be posted on your "View Invoices" tab within the hour, and your Amount Due shown below will update overnight.
                            </p>
                        </div>
                    </div>

                    <div className='row mb-5'>
                        <div className='col-12 col-lg-8 offset-lg-2'>
                            <h2 className='text-center mb-3'>Account overview</h2>
                            <div className='row text-center'>
                                <div className='col-12 col-lg-4 mb-1 mb-lg-0 font-medium d-flex align-items-center justify-content-center'>
                                    <span><span className='color-lime sub-bold'>Customer ID:&nbsp;</span>&nbsp;{this.props.customerId}</span>
                                </div>
                                <div className='col-12 col-lg-4 mb-4 mb-lg-0 font-medium d-flex align-items-center justify-content-center'>
                                    <span><span className='color-lime sub-bold'>Amount due:&nbsp;</span>&nbsp;${this.props.accountBalance}</span>
                                </div>
                                <div className='col-12 col-lg-4'>
                                    <TabNavItem to='/payment-and-invoices/pay-account' className='btn btn-custom'>Pay account now</TabNavItem>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12 col-lg-8 offset-lg-2'>
                            <h2 className='text-center mt-0 mb-3'>Recent invoices</h2>
                        </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col-12 col-lg-10 offset-lg-1'>
                            {this.state.invoices.length > 0
                                ? <React.Fragment>
                                    <ResponsiveTable data={{ headings: headings, rows: this.state.invoices }} minWidthMobile={600} />
                                    <div className='mt-4 text-center'>
                                        <TabNavItem to='/payment-and-invoices/invoices' className='btn btn-custom'>View more</TabNavItem>
                                    </div>
                                  </React.Fragment>
                                : <p className='text-center'>You currently have no invoices to view.</p>}
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

AccountOverview.propTypes = {
    accountBalance: PropTypes.number.isRequired,
    customerId: PropTypes.number.isRequired,
    customerName: PropTypes.string.isRequired
}

export default AccountOverview



// WEBPACK FOOTER //
// ./resources/js/modules/AccountOverview.js